import { Step } from 'react-joyride';
import { translate } from '../../../i18n';

export const COURT_CONFIG_TOUR_ID = 'court-configuration';

export function courtConfigTourSteps(): Step[] {
  return [
    {
      target: '[data-tour="court-details"]',
      title: translate('walkthrough.court_config_details_title'),
      content: translate('walkthrough.court_config_details_content'),
      disableBeacon: true,
    },
    {
      target: '[data-tour="court-calendar"]',
      title: translate('walkthrough.court_config_calendar_title'),
      content: translate('walkthrough.court_config_calendar_content'),
    },
    {
      target: '[data-tour="court-pricing-heatmap"]',
      title: translate('walkthrough.court_config_heatmap_title'),
      content: translate('walkthrough.court_config_heatmap_content'),
    },
  ];
}
